import type { UploadFile } from 'antd';
import { MAX_INSURANCE_FILE_SIZE } from './constants';

export const validateInsuranceFile = (
  files: UploadFile[] | undefined,
  requiredMessage: string,
  tooLargeMessage: string,
) => {
  const file = files?.[0];
  if (!file) return Promise.reject(new Error(requiredMessage));
  if (file.size && file.size > MAX_INSURANCE_FILE_SIZE) {
    return Promise.reject(new Error(tooLargeMessage));
  }
  return Promise.resolve();
};
